// Attribution helpers for the shared Vendor Directory.
//
// The generic note + rating logic now lives in utils/entryNotes.js (shared
// with the Team Directory); this file keeps the vendor-specific pieces and
// re-exports the shared ones so existing imports keep working.
import { noteList, userDisplayName } from "./entryNotes";

export { buildNote, personName, userDisplayName } from "./entryNotes";

// Who added this vendor. Vendors created before attribution existed have no
// createdBy, so callers should treat "" as unknown rather than printing it.
export function vendorAddedByName(vendor, users) {
  return userDisplayName(users, vendor && vendor.createdBy);
}

// Newest attributed notes first, with any legacy unattributed `notes` string
// kept at the bottom so nothing written before this feature is lost.
export function vendorNoteList(vendor) {
  return noteList(vendor && vendor.noteEntries, vendor && vendor.notes);
}
